import React from "react";
import { Link, useHistory } from "react-router-dom";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import Util from "../../util/util";
import Dropdown from "../ui/Dropdown";

export default function SeasonLinksDropdown({ path }) {
  const history = useHistory();
  const { leagueSeason, league } = useLeagueSeason();

  if (!league) return null;

  const { season: selectedSeasonStr } = leagueSeason.obj;
  const selectedSeason = parseInt("" + selectedSeasonStr, 10);

  const getLinkPathForItem = (seasonItem) => {
    const season = parseInt(seasonItem.id, 10);
    if (season === selectedSeason) return null;

    return Util.addSeasonToPath(season, path);
  };

  const handleSelectSeason = (seasonItem) => {
    const linkPath = getLinkPathForItem(seasonItem);
    if (linkPath !== window.location.pathname) history.push(linkPath);
  };

  let seasons = Object.keys(league.obj.seasons)
    .map((seasonStr) => parseInt(seasonStr, 10))
    .map((season) => ({
      id: season,
      value: season,
    }))
    .reverse();

  if (seasons.length === 1) {
    const linkPath = getLinkPathForItem(seasons[0]);
    return <Link to={linkPath}>{seasons[0].value}</Link>;
  }

  return (
    <Dropdown
      items={seasons}
      selectedId={selectedSeason}
      handleSelectItem={handleSelectSeason}
    />
  );
}
